import { Fragment } from 'react';
import {
  AeConfirmChangesDialog,
  AeHeadlessConfirmChanges,
  AeHorizontalEditor,
  AeHeadlessHierarchy,
  AeHierarchyItem,
  AeHierarchyItemMenu,
  AeHierarchyItemSubMenu,
  useAePerformanceLayoutHorizontalEditor,
} from '@diana/core';

export const AdvancedEditorModalContent = (props: { onClose: () => void }) => {
  const { onClose } = props;

  const horizontalEditorProps = useAePerformanceLayoutHorizontalEditor({ onClose });

  return (
    <Fragment>
      <AeHorizontalEditor {...horizontalEditorProps}>
        <AeHeadlessHierarchy
          Item={AeHierarchyItem}
          Menu={AeHierarchyItemMenu}
          SubMenu={AeHierarchyItemSubMenu}
        />
      </AeHorizontalEditor>
      <AeHeadlessConfirmChanges renderDialog={(props) => <AeConfirmChangesDialog {...props} />} />
    </Fragment>
  );
};
